import { useQuery } from '@apollo/client';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ClinicalVisitStatusBadge } from './ClinicalVisitStatusBadge';
import { CLINICAL_VISIT_BY_ORDER_QUERY } from './clinical.gql';

const CLOSED = new Set(['closed', 'addended', 'cancelled', 'voided']);

/**
 * Non-blocking advisory for the cashier: surfaces the linked clinical visit status so
 * the cashier knows the doctor hasn't closed it yet. Never blocks charging.
 */
export function CashierClinicalAdvisory({
  sale_order_id,
}: {
  sale_order_id: string;
}): JSX.Element | null {
  const { t } = useTranslation();
  const { data } = useQuery(CLINICAL_VISIT_BY_ORDER_QUERY, {
    variables: { sale_order_id },
    skip: !sale_order_id,
    fetchPolicy: 'cache-and-network',
  });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  const visit = data?.clinicalVisitByOrderId?.visit ?? null;
  if (!visit) return null;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument
  if (CLOSED.has(visit.status)) return null;

  return (
    <div className="border-warning/40 bg-warning/15 flex items-center gap-2 rounded-md border p-2 text-sm">
      <AlertTriangle className="text-warning mt-0.5 h-4 w-4" aria-hidden />
      <span className="text-warning">{t('clinical.cashier_advisory')}</span>
      {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument */}
      <ClinicalVisitStatusBadge status={visit.status} />
    </div>
  );
}
